class GameGroupMethods {
  constructor () {
    this._catenaIdItems = {
      1: '六合彩',
      2: 'pk拾',
      3: '时时彩',
      4: '快十',
      5: '快三',
      6: '11选5',
      7: '基诺彩',
      8: '福利彩',
      9: '28系列',
      10: '体育彩',
      11: '官方彩',
      12: '潮汕盘口',
    }
    this._gameGroupItems = {
      1: '六合彩',
      2: 'pk拾',
      3: '时时彩',
      4: '快十',
      5: 'pk拾',
      6: '11选5',
      8: '快三',
      9: '六合彩',
      10: '快樂8',
      11: '28系列',
      12: '排列三',
      15: '539系列',
      16: '38乐合',
      17: '三星彩',
      18: '四星彩',
      19: '北越南彩',
    }
    this._items = { // 玩法的球數長度, 球數大小, 是否可重複球號 可重複的話 要在該組件加上 BallAll: true
      1: { balls: 7, min: 1, max: 49, reusable: false },
      2: { balls: 10, min: 1, max: 10, reusable: false },
      3: { balls: 5, min: 0, max: 9, reusable: true },
      4: { balls: 8, min: 1, max: 20, reusable: false },
      5: { balls: 10, min: 1, max: 10, reusable: false },
      6: { balls: 5, min: 1, max: 11, reusable: false },
      8: { balls: 3, min: 1, max: 6, reusable: true },
      9: { balls: 7, min: 1, max: 49, reusable: false },
      10: { balls: 20, min: 1, max: 80, reusable: false },
      11: { balls: 3, min: 1, max: 9, reusable: false },
      12: { balls: 3, min: 1, max: 9, reusable: true },
      15: { balls: 5, min: 1, max: 39, reusable: false },
    }
  }
  get catenaIdItems () { // 取得 catenaId 全部的名稱
    return this._catenaIdItems
  }
  get gameGroupItems () { // 取得 catenaId 全部的名稱
    return this._gameGroupItems
  }
  get items () {
    return this._items
  }
  catenaGroup (id) { //回傳取得的資料
    if (!id) return
    return this.catenaIdItems[id]
  }
  groupName (id) {
    if (!id) return
    switch (id) {
      case 1: case 9: case 15:
        return '六合彩'
      case 2: case 5:
        return 'PK拾'
      case 3:
        return '时时彩'
      case 4:
        return '快十'
      case 6:
        return '11选5'
      case 10: case 11:
        return '基诺彩'
      case 8:
        return '快三'
      case 12:
        return '福利彩'
      default:
        return '没有此分类'
    }
  }
  groupList (all = true) {
    let list = []
    if (all) list.push({ val: 999, text: '全部' })
  }
}
export default GameGroupMethods